import React from "react";

const CrossMarkIcon = () => (
  <svg className="crossmark-icon" x="0px" y="0px" viewBox="0 0 18 18">
    <defs>
      <clipPath id="clipPath">
        <rect width="18" height="18" fill="none" />
      </clipPath>
    </defs>
    <g id="close" clipPath="url(#clipPath)">
      <path
        id="close-2"
        d="M-1844.142,17.642l0,0L-1851,10.679l-6.852,6.962h0a1.249,1.249,0,0,1-.878.36A1.276,1.276,0,0,1-1860,16.714a1.291,1.291,0,0,1,.355-.892h0L-1852.928,9l-6.631-6.737a1.293,1.293,0,0,1-.441-.975A1.276,1.276,0,0,1-1858.734,0a1.247,1.247,0,0,1,.875.358l0,0L-1851,7.322l6.853-6.962h0a1.249,1.249,0,0,1,.878-.36A1.276,1.276,0,0,1-1842,1.286a1.291,1.291,0,0,1-.355.892h0L-1849.073,9l6.631,6.737a1.293,1.293,0,0,1,.441.975A1.276,1.276,0,0,1-1843.266,18,1.247,1.247,0,0,1-1844.142,17.642Z"
        transform="translate(1860)"
        fill="#ff6969"
      />
    </g>
  </svg>
);

export default CrossMarkIcon;
